export default __webpack_public_path__ + "static/167-52f49f9720f6e30c678451af89abaac6.jpg";